<div class="panel-body ">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedParties.length === 0)">
        <div class="panel-title">
            Related Parties
        </div>
        <div class="panel-body ">
            No Related Parties information available for this allegation.
        </div>
    </div>
    <!-- <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedParties.length === 0)">
        No Related Parties information available for this allegation.
    </div> -->
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="(relatedParties.length !== 0)">
      <div class="panel-title">
        Related Parties
      </div>
     <div class="panel-body ">
       <div class="row table-responsive">
      <table id="relatedAllegations-table" class="table table-condensed table-striped">
     <thead>
       <tr>
        <th id="V122c">
          <span class="field-code ">V122c json='party'</span>
          Party
        </th>
        <th id="V121c">
          <span class="field-code ">V121c json='serviceDate'</span>
            Service Date
          </th>
        </tr>
     </thead>
     <tbody *ngFor="let party of relatedParties; let i = index">
       <tr >
        <td id="{{'juvenile-caseDetails-parties-' + i + '-eventTypeOutcome'}}">{{party.getPartyName() +' ('+ party.getPartyType() + ')'}}</td>
        <td id="{{'juvenile-caseDetails-parties-' + i + '-dateTime' }}">{{party.getServiceDate() | date:'MM/dd/yyyy'}}</td>
      </tr>
     </tbody>
     </table>
     </div>
    </div>
   </div>   
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/related-parties/related-parties.component.html